<template>
  <div class="bottom-div-empty"></div>
</template>

<script>
  export default {
    name: "EmptyBottom"
  }
</script>

<style lang="scss" scoped>
  .bottom-div-empty {
    padding-bottom: 45px;
    background: white;
  }
</style>
